// AddVehicleCard.jsx
import styled from 'styled-components';
import Typography from '../Typography';
import { theme } from '../../theme';
import AddCircleSolidIcon from '../Icons/AddCircleSolidIcon';
import { useTranslation } from 'react-i18next';

function AddVehicleCard({ onClick }) {
  const { t } = useTranslation('userProfile');

  return (
    <CardContainer onClick={onClick}>
      <CardContent>
        <AddCircleSolidIcon fill={theme.colors.defaultMain} />
        <Typography $variant="title-5-medium">
          {t('garage.vehicle.addVehicle')}
        </Typography>
      </CardContent>
    </CardContainer>
  );
}

export default AddVehicleCard;

// Estilos de ejemplo
const CardContainer = styled.li`
  align-items: center;
  aspect-ratio: 4 / 3;
  background: var(--bg-default-main, #FFF);
  border: 2px dashed ${({ theme }) => theme.border.defaultWeak};  
  border-radius: ${({ theme }) => theme.radius.xs};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ theme }) => theme.sizing.sm};
  transition: all 0.3s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.fill.defaultSubtle};
  }
`;

const CardContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  justify-content: center;
`;